import { useEffect, useRef, useState } from "react";
import { SxProps, Typography } from "@mui/material";

import { FormatterType, useFormat } from "hooks/useFormat";

const getCurrentDay = (format: FormatterType) => {
  const formattedDate = format(new Date(), "PPPPp");
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

type DateTimeTextProps = {
  sx?: SxProps;
};

function DateTimeText({ sx }: DateTimeTextProps) {
  const { format } = useFormat();
  const intervalRef = useRef<
    ReturnType<typeof globalThis.setInterval> | undefined
  >(undefined);

  const [currentDateTime, setCurrentDateTime] = useState<string>(
    getCurrentDay(format),
  );

  useEffect(() => {
    if (intervalRef.current) {
      globalThis.clearInterval(intervalRef.current);
    }
    setCurrentDateTime(getCurrentDay(format));
    intervalRef.current = globalThis.setInterval(() => {
      setCurrentDateTime(getCurrentDay(format));
    }, 10 * 1000);

    return () => {
      globalThis.clearInterval(intervalRef.current);
    };
  }, [format]);

  return <Typography sx={sx}>{currentDateTime}</Typography>;
}
export default DateTimeText;
